import React from 'react';
import { Link } from 'react-router-dom';
import logo from './logo.svg';
import subQueryLogo from './images/subquery/subquery-logo-light-text.svg';
import subspaceLogo from './images/subspace/subspace-logo-full.png';
import theGraphLogo from './images/thegraph/thegraph-email-logo.png';
import celestiaLogo from './images/celestia/celestia-logo-black.svg';
import './App.css';

const projects = [
  {
    path: '/subquery',
    logo: subQueryLogo,
    alt: 'SubQuery Network',
    description: 'Indexer & node operator on the SubQuery decentralised network.',
  },
  {
    path: '/subspace',
    logo: subspaceLogo,
    alt: 'Subspace Network',
    description: 'Farmer and ambassador on the Subspace Network.',
  },
  {
    path: '/thegraph',
    logo: theGraphLogo,
    alt: 'The Graph Network',
    description: 'Mainnet indexer participating in The Graph protocol.',
  },
  {
    path: '/celestia',
    logo: celestiaLogo,
    alt: 'Celestia Network',
    description: 'Genesis mainnet validator on the Celestia modular blockchain.',
  },
];

function App() {
  return (
    <div className="home">
      <section className="home-hero">
        <img src={logo} className="home-hero-logo" alt="Counterpoint Software" />
        <h1 className="home-hero-title">counterpoint software</h1>
        <p className="home-hero-subtitle">
          Software development and DevOps services for Web3 and blockchain projects.
        </p>
        <a
          className="home-hero-cta"
          href="mailto:info@counterpoint.software?subject=Website Contact"
        >
          Get in touch
        </a>
      </section>

      <section className="home-projects">
        <div className="home-projects-inner">
          <h2 className="home-projects-heading">Projects</h2>
          <div className="home-project-grid">
            {projects.map((p) => (
              <Link key={p.path} to={p.path} className="home-project-card">
                <div className="home-project-card-logo-wrap">
                  <img src={p.logo} alt={p.alt} className="home-project-card-logo" />
                </div>
                <p className="home-project-card-desc">{p.description}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;
